<template>
    <div
        class="mt-input mt-input--textarea"
        :class="{ disabled, active, filled, invalid: !valid }"
    >
        <div v-if="coins" class="coins">{{ coins }}</div>
        <span
            v-if="label"
            class="label"
            :class="{ 'hold-place': !filled, invalid: !valid }"
        >
            {{ label }}
            <span class="required" v-if="required">&nbsp;&nbsp;*</span>
        </span>

        <textarea
            class="mt-input__value"
            :type="type"
            :class="{ disabled }"
            :disabled="disabled"
            :maxlength="maxlength"
            v-model="innerValue"
            @focus="active = true"
            @blur="active = false"
        ></textarea>

        <div v-if="counter && maxlength" class="counter">
            {{ innerValue ? innerValue.length : 0 }} / {{ maxlength }}
        </div>
        <div v-else-if="counter" class="counter">
            {{ innerValue ? innerValue.length : 0 }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'ModelTextArea',
    props: {
        coins: Number,
        label: String,
        value: {
            type: [String, Object, Array, Number],
        },
        type: {
            type: String,
            default: 'text',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        valid: {
            type: Boolean,
            default: true,
        },
        maxlength: {
            type: Number,
            default: null,
        },
        required: {
            type: Boolean,
            default: false,
        },
        counter: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            innerValue: this.value !== null ? this.value : '',
            active: false,
        };
    },
    model: {
        prop: 'value',
        event: 'change',
    },
    watch: {
        value(str) {
            this.innerValue = str;
        },
        innerValue(str) {
            this.$emit('change', str);
        },
    },
    computed: {
        filled() {
            return this.active || this.value;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/rem';
@import '../../../styles/mrem';
@import '../../../styles/mt';
/*activate checkbox regExp in finder of phpStorm*/
/*find      {: ([0-9]*)px}*/
/*replace   {: rem($1);}*/

.data-model {
    display: flex;
    justify-content: center;
    align-items: center;
    height: rem(125);

    &.disabled {
        opacity: 0.5;
        pointer-events: none;
    }
    .invalid {
        color: red;
        font-weight: bold;
    }
}

textarea {
    width: 96%;
    height: 90%;
    border: none;
    font-size: 0.9rem;
    border-radius: inherit;
    resize: none;
    font-family: 'Open Sans', sans-serif;
}
@import '../../../styles/variables';

.counter {
    position: absolute;
    font-weight: 400;
    z-index: 1;
    pointer-events: none;
    font-size: rem(12);
    bottom: rem(-8);
    right: rem(10);
    padding: rem(2);
    background: #fff;
    color: #98a0a9;
}

@media (max-width: $vm) {
    .data-model {
        display: flex;
        justify-content: center;
        align-items: center;
        height: mrem(125);
        border-radius: mrem(4);
        border: mrem(1) solid #d2d5d9;

        &.disabled {
            opacity: 0.5;
            pointer-events: none;
        }
        .invalid {
            color: red;
            font-weight: bold;
        }
    }
    .label {
        left: mrem(13);
        white-space: normal !important;
        font-weight: 600;
        z-index: 1;
        pointer-events: none;
        -webkit-transition: 0.1s;
        transition: 0.1s;
        font-size: mrem(16);
        top: -mrem(10);
        &.hold-place {
            top: mrem(10);
            background-color: transparent;
            font-size: mrem(16);
            font-weight: 500;
        }
    }
    .counter {
        font-size: mrem(12);
        bottom: mrem(-8);
        right: mrem(10);
        padding: mrem(2);
    }

    textarea {
        width: 96%;
        height: 90%;
        border: none;
        font-size: mrem(16);
        border-radius: inherit;
        resize: none;
        font-family: 'Open Sans', sans-serif;
        padding-top: 10px;
    }
}
</style>
